module.exports = __webpack_public_path__ + "img/hospitality-list-image.e4c02418.png";